module.exports = __webpack_public_path__ + "static/3-e99ad4644dbeeea1b72df4cc206c82e8.jpg";